import { MedicamentosListSearchComponent } from './MedicamentosListSearchComponent'
import { MedicamentosListToolbar } from './MedicamentosListToolbar'

export const MedicamentosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <MedicamentosListSearchComponent actions={<MedicamentosListToolbar />} />
    </div>
  )
}
